import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";
import { REAGENDAMENTO_AUTOMATION_CODES } from "../../../../../../../utils/ticketAutomation";

const translationPath = "components.messages.";

export const InternalProcedureField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    ![
      "1",
      "5",
      "11",
      "12",
      "13",
      "14",
      "16",
      "17",
      "18",
      "22",
      "23",
      "24",
      "34",
      ...REAGENDAMENTO_AUTOMATION_CODES,
    ].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="internalProcedure"
        fullWidth
        label={t(translationPath + "internalProcedure") || "internalProcedure"}
      />
      <FormHelperText>
        {t(translationPath + "internalProcedureMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
